import { zeroPad } from '@/shared/lib';
import { t } from 'ttag';

/**
 * Names the PDF file for one shipping label of an RMA ticket. Zero-pads the RMA id to five digits and appends the one-based label index to the translated filename template.
 *
 * @param index - Zero-based index of the label within the ticket.
 * @param id - RMA ticket id.
 * @returns Filename for the RMA shipping label PDF.
 */
const formatShippingLabel = (index: any, id: any) => {
  const idText = zeroPad(id, 5);
  const indexText = index + 1;
  return t`RMA_${idText}_Shipping_Label${indexText}.pdf`;
};

export default formatShippingLabel;
